/*
  src/redux/callAuth.js

  Created by erikchristensen on 10/19/2016.
  Copyright © 2016 myNfo. All rights reserved.
*/
import axios from 'axios';

import {
  AUTH_URL,
  APPLICATION_ID,
  APPLICATION_SECRET,
  UPDATE_LATENCY
} from '../config';

function toQueryString(obj){
  let parts = [];
  for (let i in obj) {
    if (obj.hasOwnProperty(i)){
      parts.push(`${encodeURIComponent(i)}=${encodeURIComponent(obj[i])}`);
    }
  }
  return parts.join('&');
}

// callAuth({
//   method:'GET',
//   path:'/foo',
//   begin:{
//     type:FOO_REQUESTED,
//   },
//   success:{
//     type:FOO_LOADED,
//     payload:(res) => res.data,
//     result:(res) => res.data
//   },
//   failure:{
//     type:FOO_FAILED_TO_LOAD
//   }
// })

export default function callAuth(options){
  return function(dispatch,getState){
    const token = window.btoa(APPLICATION_ID+':'+APPLICATION_SECRET);

    const headers = {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      'Accept': 'application/json',
      'Authorization': 'Basic ' + token
    };

    if (options.begin) {
      dispatch({
        type: options.begin.type,
        payload: options.begin.payload ? options.begin.payload() : null
      });
    }

    return axios({
      url: AUTH_URL+options.path,
      method:options.method || 'GET',
      headers:headers,
      data: options.body ? toQueryString(options.body) : null
    })

    // Handle 404 error
    .catch(err => {
      if (err.response.status === 404 || options.allow404)
        return err.response;
      else
        throw err;
    })
    .then(res => ( res.data || {} ))

    // Optional - Delay results
    .then((result) => {
      return new Promise((resolve) => {
        if(!options.method || options.method === 'GET' || options.skipTimeout){
          resolve(result);
        } else {
          window.setTimeout( () => {
            resolve(result);
          }, UPDATE_LATENCY);
        }
      });
    })

    // Perform Success Action
    .then((res) => {
      // Dispatch Success
      if (options.success) {
        dispatch({
          type: options.success.type,
          payload: (options.success.payload) ? options.success.payload(res) : res
        });

        // Callbacks
        if(options.success.result){
          return options.success.result(res);
        }
      }

      return res;
    })
    .catch((err) => {
      if (options.failure) {
        dispatch({
          type:options.failure.type,
          payload:options.failure.payload ? options.failure.payload(err) : err,
          error:true
        });
      }

      throw err;
    });
  }
}



// WEBPACK FOOTER //
// ./src/redux/callAuth.js